module.exports = require("uuid");